import React from 'react';

import ErrorLayout from 'src/layouts/error-layout';
import Button from 'src/components/ui/button';

import { ErrorText, LOCALES } from 'src/constants';
import { redirectToMain } from 'src/utils';
import type { ErrorPageProps } from './error-page.props';

import './error-page.scss';

const ErrorPage = ({ error = ErrorText.DEFAULT }: ErrorPageProps) => {
  return (
    <ErrorLayout>
      <div className="error-page">
        <h1 className="error-page__text">
          <span className="error-page__text-accent">500</span>
          <span className="error-page__text-subtitle">{error}</span>
        </h1>

        <div className="error-page__buttons">
          <Button
            className="error-page__button"
            label={LOCALES.RELOAD_PAGE}
            onClick={() => window.location.reload()}
            size="oversize"
            tag="button"
            theme="outlined"
          />

          <Button
            className="error-page__button"
            label={LOCALES.BACK_TO_HOME_PAGE}
            onClick={redirectToMain}
            size="oversize"
            tag="button"
            theme="plain"
          />
        </div>
      </div>
    </ErrorLayout>
  );
};

export default ErrorPage;
